import React, { useEffect } from 'react';
import VaultCapModal from './VaultCapModal';
import { cloudCap, keepItemsOnDevice, useVaultCapStore } from '../services/vaultCloudCap';

/**
 * The cap card for the race (card U1): the server refused new vault items
 * because the free cloud vault filled up meanwhile (another device). They are
 * already saved here; "Keep on this device only" makes that stick. Ids that
 * arrive while Keep runs stay on the card.
 */
export default function VaultCapPrompt() {
  const { open, ids, cap, close, settle, setCap } = useVaultCapStore();

  // The refusal carries no numbers the card can show; read them once it opens.
  useEffect(() => {
    if (!open || cap) return;
    cloudCap({ fresh: true }).then((c) => c && useVaultCapStore.getState().open && setCap(c));
  }, [open, cap, setCap]);

  const keep = async () => {
    const handled = [...ids];
    await keepItemsOnDevice(handled);
    settle(handled);
  };

  return <VaultCapModal isOpen={open} cap={cap} count={ids.length} onKeepOnDevice={keep} onClose={close} closeOnKeep={false} />;
}
